
 <div >
    <h1 class="page-title">
        
        {{props.label}}
        
    </h1>
     <ng-container #fieldComponent></ng-container>
   
  </div>